import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ClassNames, css } from '@emotion/react';
import styled from '@emotion/styled/macro';
import ReactModal from 'react-modal';
import { colors, fonts, zindex, leading, animate } from '../../styles/theme';
import { Icon } from '../../ui_elements/icons';
import { H2 } from '../../base';

const CloseIcon = styled(Icon)`
  font-size: ${fonts.sans.size.xlarge};
  position: absolute;
  cursor: pointer;
  top: 20px;
  right: 20px;
  color: ${colors.grey.primaryLight};
`;

const contentStyles = css`
  background: ${colors.white};
  position: relative;
  top: 60px;
  margin: 0 auto;
  max-width: 1130px;
  width: 70%;
  z-index: ${zindex.modal.body};
  margin-bottom: 60px;
  border-radius: 5px;
  border: none;
  box-shadow: 0 1px 2px 0 ${colors.grey.primary};
  padding: 0;
  outline: 0;
  @media screen and (max-width: 700px) {
    width: auto;
    left: auto;
    margin: 0 20px;
  }
`;

const overlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${zindex.modal.below};
  background-color: rgba(51, 51, 51, 0.5);
  overflow-y: auto;
  transition: all ${animate.transition} ease;
`;

export const ModalActions = styled('div')`
  text-align: right;
  position: relative;
  width: 100%;
  vertical-align: top;
  display: inline-block;
  padding: 15px 30px;
  margin-top: ${leading.half};
  background: ${colors.grey.secondaryLight};
  border-top: 1px solid ${colors.grey.secondaryDark};
  border-radius: 0 0 5px 5px;
  box-sizing: border-box;

  &:empty {
    display: none;
  }
`;

export const ModalHeader = styled(H2)`
  padding: 30px 30px 0;
`;

export const ModalBody = styled('div')`
  padding: ${leading.half} 30px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  &:last-child {
    margin-bottom: ${leading.full};
  }
`;

const modalBodyStyles = css`
  overflow: hidden;
`;

export class Modal extends PureComponent {
  render() {
    const { isOpen, shouldCloseOnEsc, shouldCloseOnOverlayClick, onClose, children, style, appElement } =
      this.props;

    const closeIcon =
      shouldCloseOnOverlayClick || shouldCloseOnEsc ? (
        <CloseIcon type="x" onClick={onClose} />
      ) : null;

    return (
      <ClassNames>
        {({ css: cssProp }) => (
          <ReactModal
            style={style}
            onRequestClose={onClose}
            isOpen={isOpen}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
            shouldCloseOnEsc={shouldCloseOnEsc}
            className={cssProp(contentStyles)}
            overlayClassName={cssProp(overlayStyles)}
            bodyOpenClassName={cssProp(modalBodyStyles)}
            ariaHideApp={process.env.NODE_ENV !== 'test'}
            appElement={appElement || document.getElementById('root')}
          >
            {closeIcon}
            {children}
          </ReactModal>
        )}
      </ClassNames>
    );
  }
}

Modal.propTypes = {
  sizeOverride: PropTypes.shape({}),
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  shouldCloseOnOverlayClick: PropTypes.bool,
  shouldCloseOnEsc: PropTypes.bool,
};

Modal.defaultProps = {
  children: null,
  shouldCloseOnOverlayClick: true,
  shouldCloseOnEsc: true,
};
